import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { Observable } from 'rxjs'
import moment from 'moment'
import { environment } from '@environments/environment'

type TParams = {
    [param: string]:
        | string
        | number
        | boolean
        | readonly (string | number | boolean)[]
}

@Injectable({
    providedIn: 'root',
})
export class BaseHttpService {
    private readonly _apiUrl: string = environment.apiUrl

    constructor(protected http: HttpClient) {}

    protected get<T>(url: string, params?: Record<string, any>): Observable<T> {
        params = this.normalBody(params)
        return this.http.get<T>(this._apiUrl + url, { params: params ?? {} })
    }

    protected post(
        url: string,
        body: Record<string, any> | null,
        options?: { headers?: Record<string, string>; params: TParams }
    ): Observable<any> {
        body = this.normalBody(body)
        return this.http.post(this._apiUrl + url, body, {
            headers: options?.headers,
            params: options?.params,
        })
    }

    protected put(
        url: string,
        body: Record<string, any> | null,
        options?: {
            headers?: Record<string, string>
            params: TParams
        }
    ): Observable<any> {
        body = this.normalBody(body)
        return this.http.put(this._apiUrl + url, body, {
            headers: options?.headers,
            params: options?.params,
        })
    }

    protected remove(
        url: string,
        params?: Record<string, any>
    ): Observable<any> {
        params = this.normalBody(params)
        return this.http.delete(this._apiUrl + url, { params: params ?? {} })
    }

    normalBody(body: any): any {
        if (!body) {
            return {}
        }

        if (body instanceof FormData) {
            return body
        }

        const normalizedBody: Record<string, any> = {}

        for (const [key, value] of Object.entries(body)) {
            if (value !== null && value !== undefined && value !== '') {
                normalizedBody[key] =
                    value instanceof Date ? this.formatDate(value) : value
            }
        }

        return normalizedBody
    }

    formatDate(date: any) {
        return moment(date).format('YYYY-MM-DD[T]HH:mm:ss')
    }

    parseFormData(body: Record<string, any>) {
        const formData = new FormData()
        for (const key in body) {
            if (body[key]) {
                if (body[key] instanceof Array) {
                    body[key].forEach((item: any) => {
                        formData.append(key, item)
                    })
                }
                formData.append(key, body[key])
            }
        }
        return formData
    }
}
